import { render, staticRenderFns } from "./AddBoardItems.vue?vue&type=template&id=dfc074ee"
import script from "./AddBoardItems.vue?vue&type=script&lang=js"
export * from "./AddBoardItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports